import React, { Component } from "react";
import { Box, Button, Column, Columns, Control, Field, Input, Select, TextArea } from "@allxsmith/bestax-bulma";
import ContactSection from "../Contact/ContactSection";

class Inspection extends Component {
  state = {
    ...this.props.inspection,

    vehicle: this.props.vehicle || undefined
  };

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value }, () => {
      this.props.update_inspection(this.state, this.props.index);
    });
  };

  render() {
    return (
      <Box>
        <Columns isMultiline>
          <Column>
            <Columns isMultiline>
              <Column>
                <Field>
                  <Control>
                    <label className="label">Inspection Type</label>
                    <Select
                      onChange={this.handleChange}
                      name="inspection_type"
                      value={this.state.inspection_type}
                      disabled={this.state.booked_in_date}
                    >
                      {this.props.types.map(value => (
                        <option
                          key={value.inspection_type}
                          value={value.inspection_type}
                        >
                          {value.inspection_type}
                        </option>
                      ))}
                    </Select>
                  </Control>
                </Field>
              </Column>
              <Column>
                <Field>
                  <Control>
                    <label className="label">Expiry Date</label>
                    <Input
                      className="input"
                      type="date"
                      name="expiry_date"
                      onChange={this.handleChange}
                      value={this.state.expiry_date || ""}
                      disabled={this.state.booked_in_date}
                    />
                  </Control>
                </Field>
              </Column>
              <Column>
                <Field>
                  <Control>
                    <label className="label">Last Completed</label>
                    <Input
                      type="date"
                      name="date_completed"
                      onChange={this.handleChange}
                      value={this.state.date_completed || ""}
                      disabled={this.state.booked_in_date}
                      required
                    />
                  </Control>
                </Field>
              </Column>
            </Columns>
            <Columns isMultiline>
              <Column>
                <Field>
                  <Control>
                    <label className="label">Comments</label>
                    <TextArea
                      type="textarea"
                      name="comments"
                      onChange={this.handleChange}
                      value={this.state.comments}
                      required
                    />
                  </Control>
                </Field>
              </Column>
            </Columns>

            <Button
              color="danger"
              onClick={() => this.props.remove_inspection(this.props.index)}
            >
              Remove Inspection
            </Button>
          </Column>

          <Column>
            <ContactSection
              title="Inspection Workshop"
              contactUpdate={ws =>
                this.handleChange({
                  target: { name: "inspection_workshop", value: ws }
                })
              }
              endpoint={this.props.endpoint + "contacts"}
              contact={this.state.inspection_workshop || {}}
              type="SP"
            />
          </Column>
        </Columns>
      </Box>
    );
  }
}

export default Inspection;
